import { Component, EventEmitter, Input, Output, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatRadioChange } from "@angular/material/radio";
import { ListItem } from "src/app/models/listItem";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-radio-button',
    templateUrl: './radio-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RadioButtonComponent {
    @Input() public form: FormGroup;
    @Input() public nameForControl: string;
    @Input() public labelName: string;
    @Input() public data: any[];
    @Input() public dataEnum: any;
    @Input() public keyText: string;
    @Input() public keyValue: string;
    @Input() public displayInline: boolean = true;
    @Input() public autoTranslate: boolean;
    @Input() public noSpacing: boolean;
    @Input() public disabled: boolean;
    @Input() public useCheckMarkStyle: boolean;

    @Output() public emitSelected: EventEmitter<any> = new EventEmitter();

    public list: ListItem[];

    constructor(
        public helperService: HelperService
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.data)
            this.list = this.helperService.convertModelToList(this.data, this.keyText, this.keyValue);
        else
            this.list = this.helperService.convertEnumToList(this.dataEnum);
    }

    public onChange(event: MatRadioChange): void {
        if (event.source) {
            this.emitSelected.emit(event.source.value);
        }
    }
}